import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const DraggableRow = ({ id, children, data }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useDraggable({
    id: id,
    data: {
      row: "normal",
      type: "row", // Specify the type of draggable item
      values: data,
    },
  });

  return (
    <tr
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={`${isDragging ? "dragging" : ""}`}
      style={{
        cursor: "grab",
        opacity: isDragging ? 0.7 : 1,
        transform: CSS.Transform.toString(transform),
        transition,
        backgroundColor: isDragging ? "#f8f9fa" : "transparent",
        // transform: isDragging ? "scale(1.02)" : "scale(1)",
        // transition: "transform 0.2s ease",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </tr>
  );
};

export default DraggableRow;
